import { MouseEvent, ReactElement, useState } from 'react';

import { Tooltip, Typography } from '@mui/material';

import copyToClipboard from 'copy-to-clipboard';

import { VersionIdProps } from './types';

function VersionId({ id, sx, ignoreClick, containerProps = {} }: VersionIdProps) {
  const [isCopied, setIsCopied] = useState(false);

  function handleCopy(ev: MouseEvent<HTMLSpanElement>) {
    if (ignoreClick) return;
    ev.stopPropagation();
    ev.preventDefault();
    copyToClipboard((id as ReactElement)?.props?.children || id);
    setIsCopied(true);
  }

  function handleTooltipClose() {
    setTimeout(() => {
      setIsCopied(false);
    }, 300);
  }

  return (
    <Tooltip
      title={ignoreClick ? '' : isCopied ? 'Copied!' : 'Copy ID'}
      onClose={handleTooltipClose}
      placement="top"
    >
      <Typography
        onClick={handleCopy}
        color="text.subtle"
        sx={{ cursor: ignoreClick ? 'inherit' : 'pointer', ...sx }}
        {...containerProps}
      >
        {id}
      </Typography>
    </Tooltip>
  );
}

export default VersionId;
